import {
  getAuth,
  GoogleAuthProvider,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
} from "firebase/auth";
import { TYPES } from "./login.types";
import { PROJECT_ID } from "config/keys/user";
import { getApp } from "firebase/app";
import { getFirebaseAuthErrorMessage } from "util/auth.util";

const app = getApp(PROJECT_ID);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
provider.addScope("email");

// -------------------------- LOGIN --------------------------
export const firebaseLogin =
  ({ login }, callback) =>
  async (dispatch) => {
    firebaseLoading(dispatch);
    const email = login.email;
    const password = login.password;

    return loginWithAdmin({ email, password, dispatch, callback });
  };

// By Admin
const loginWithAdmin = ({ email, password, dispatch, callback }) => {
  signInWithEmailAndPassword(auth, email, password)
    .then(() => {
      if (callback) {
        callback({
          status: 200,
          data: "Successfully",
        });
      }
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = getFirebaseAuthErrorMessage(errorCode);
      if (callback) {
        callback({
          status: 500,
          data: errorMessage,
        });
      }
    });
};

// đăng nhập với google.
export const firebaseLoginWithGoogle = (callback) => (dispatch) => {
  return signInWithPopup(auth, provider)
    .then((user) => {
      if (user) {
        console.log({ user });
        callback && callback({ status: 200 });
      }
    })
    .catch((err) => {
      console.log({ err });
      const errorMessage = getFirebaseAuthErrorMessage(err.code);
      callback &&
        callback({ status: 500, data: errorMessage || "Please try again!" });
    });
};

// -------------------------- Logout --------------------------

export const firebaseLogout = (callback) => (dispatch) => {
  signOut(auth).then(() => {});
  firebaseLogoutSuccess(dispatch);
  if (callback) {
    callback();
  }
};

export const setLoadingSuccess = () => (dispatch) => {
  firebaseLoginSuccess(dispatch);
};

export const setLoginFail = (error) => (dispatch) => {
  firebaseLoginFail(dispatch, error);
};

// -------------------------- Dispatch --------------------------

const firebaseLoading = (dispatch) => {
  dispatch({
    type: TYPES.LOGIN_LOADING,
  });
};

const firebaseLoginSuccess = (dispatch) => {
  dispatch({
    type: TYPES.LOGIN_SUCCESS,
  });
};

const firebaseLoginFail = (dispatch, error) => {
  dispatch({
    type: TYPES.LOGIN_FAILED,
    payload: error,
  });
};

const firebaseLogoutSuccess = (dispatch) => {
  dispatch({
    type: TYPES.LOGOUT_SUCCESS,
  });
};
